const SQUAD_STATUS = {
  active: "ACTIVE",
  inactive: "INACTIVE",
  archived: "ARCHIVED",
};

export default SQUAD_STATUS;
